module.exports = __webpack_public_path__ + "static/media/Escuela.58a83656.jpg";